import { SET_DATE } from "./types"

export const setDate = payload => dispatch => {
    dispatch({
        type: SET_DATE,
        payload,
    })
}